import { Tag } from "antd";
import { EListingSellOrRent } from "../types/listing.type";
import NotSet from "./NotSet";
import styled from "styled-components";

interface SellOrRentComponentProps {
	value?: EListingSellOrRent;
}
const SellOrRentComponent: React.FC<SellOrRentComponentProps> = ({ value }) => {
	if (value === EListingSellOrRent.RENT) {
		return <CustomTag style={{ width: 74, textAlign: "center" }}>Rent</CustomTag>;
	} else if (value === EListingSellOrRent.SELL) {
		return (
			<Tag
				color="blue"
				style={{ width: 74, textAlign: "center" }}
			>
				Sale
			</Tag>
		);
	} else {
		return <NotSet />;
	}
};
export default SellOrRentComponent;

const CustomTag = styled(Tag)`
	color: #563d2d;
	border: 1px solid #563d2d;
	background-color: #e6e5e4;
`;
